{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "Ingeschakeld",
          "DISABLED": "Uitgeschakeld"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Verzonden door",
          "BOT": "Bot",
          "FROM": "van",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "Annuleren",
        "CREATE_BUTTON_TEXT": "Aanmaken",
        "FORM": {
          "TITLE": {
            "LABEL": "Titel",
            "PLACEHOLDER": "Please enter the title of campaign",
            "ERROR": "Title is required"
          },
          "MESSAGE": {
            "LABEL": "Bericht",
            "PLACEHOLDER": "Please enter the message of campaign",
            "ERROR": "Bericht is vereist"
          },
          "INBOX": {
            "LABEL": "Selecteer een inbox",
            "PLACEHOLDER": "Selecteer een inbox",
            "ERROR": "Inbox is required"
          },
          "SENT_BY": {
            "LABEL": "Verzonden door",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "Sender is required"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Please enter the URL",
            "ERROR": "Voer een geldige URL in"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Time on page(Seconds)",
            "PLACEHOLDER": "Please enter the time",
            "ERROR": "Time on page is required"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "Enable campaign",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Trigger only during business hours"
          },
          "BUTTONS": {
            "CREATE": "Aanmaken",
            "CANCEL": "Annuleren"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "There was an error. Please try again."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "There was an error. Please try again."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "Processing",
          "COMPLETED": "Completed",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "Annuleren",
        "CREATE_BUTTON_TEXT": "Aanmaken",
        "FORM": {
          "TITLE": {
            "LABEL": "Titel",
            "PLACEHOLDER": "Please enter the title of campaign",
            "ERROR": "Title is required"
          },
          "MESSAGE": {
            "LABEL": "Bericht",
            "PLACEHOLDER": "Please enter the message of campaign",
            "ERROR": "Bericht is vereist"
          },
          "INBOX": {
            "LABEL": "Selecteer een inbox",
            "PLACEHOLDER": "Selecteer een inbox",
            "ERROR": "Inbox is required"
          },
          "AUDIENCE": {
            "LABEL": "Audience",
            "PLACEHOLDER": "Select the customer labels",
            "ERROR": "Audience is required"
          },
          "SCHEDULED_AT": {
            "LABEL": "Scheduled time",
            "PLACEHOLDER": "Please select the time",
            "ERROR": "Scheduled time is required"
          },
          "BUTTONS": {
            "CREATE": "Aanmaken",
            "CANCEL": "Annuleren"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "There was an error. Please try again."
          }
        }
      }
    },
    "WHATSAPP": {
      "HEADER_TITLE": "WhatsApp campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No WhatsApp campaigns are available",
        "SUBTITLE": "Launch a WhatsApp campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "PROCESSING": "Processing",
          "COMPLETED": "Completed",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create WhatsApp campaign",
        "CANCEL_BUTTON_TEXT": "Annuleren",
        "CREATE_BUTTON_TEXT": "Aanmaken",
        "FORM": {
          "TITLE": {
            "LABEL": "Titel",
            "PLACEHOLDER": "Please enter the title of campaign",
            "ERROR": "Title is required"
          },
          "INBOX": {
            "LABEL": "Selecteer een inbox",
            "PLACEHOLDER": "Selecteer een inbox",
            "ERROR": "Inbox is required"
          },
          "TEMPLATE": {
            "LABEL": "WhatsApp Template",
            "PLACEHOLDER": "Select a template",
            "INFO": "Select a template to use for this campaign.",
            "ERROR": "Template is required",
            "PREVIEW_TITLE": "Verwerk {templateName}",
            "LANGUAGE": "Taal",
            "CATEGORY": "Categorie",
            "VARIABLES_LABEL": "Variabelen",
            "VARIABLE_PLACEHOLDER": "Enter value for {variable}"
          },
          "AUDIENCE": {
            "LABEL": "Audience",
            "PLACEHOLDER": "Select the customer labels",
            "ERROR": "Audience is required"
          },
          "SCHEDULED_AT": {
            "LABEL": "Scheduled time",
            "PLACEHOLDER": "Please select the time",
            "ERROR": "Scheduled time is required"
          },
          "BUTTONS": {
            "CREATE": "Aanmaken",
            "CANCEL": "Annuleren"
          },
          "API": {
            "SUCCESS_MESSAGE": "WhatsApp campaign created successfully",
            "ERROR_MESSAGE": "There was an error. Please try again."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Weet u zeker dat u wilt verwijderen?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "Verwijderen",
      "API": {
        "SUCCESS_MESSAGE": "Campaign deleted successfully",
        "ERROR_MESSAGE": "There was an error. Please try again."
      }
    }
  }
}
